import { useState } from 'react';
import Modal from '@components/shared/Modal/Modal';
import { useTexts } from 'utils/useTexts';
import HowToGuideModal from '@components/HowtoGuideModal/HowToGuideModal';
import Footer from '@components/shared/Footer/Footer';
import YourInformationManuallyForm from '@components/YourInformationManuallyForm/YourInformationManuallyForm';

const YourInformationManually = () => {
  const { t } = useTexts();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => setIsModalOpen(false);
  return (
    <>
      <Modal
        title={t('howToGuideModal.title')}
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <HowToGuideModal />
      </Modal>
      <YourInformationManuallyForm />

      <Footer text={t('yourInformation.footer')} />
    </>
  );
};

export default YourInformationManually;
